export default __webpack_public_path__ + "static/media/music_and_festivals.08d7f8f2.jpg";